import React from "react";

import { handleScroll } from "utils/helperFunctions";
import { Header } from "layouts/elements/Header";
import { HeaderButton, TextForButton } from "components";
import { orange, white } from "styles/colors";

export const HeaderWithButton = () => (
  <Header justifyContent='space-between'>
    <HeaderButton
      background={orange}
      onClick={() => handleScroll("section-end")}
    >
      <TextForButton color={white}>Start Now</TextForButton>
    </HeaderButton>
  </Header>
);